import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { TabBarContainer, TabBarItemContainer } from './elements';

const TabBar = ({ children }) => <TabBarContainer>{children}</TabBarContainer>;

const TabBarItem = ({ children, to, location }) => (
  <Link to={to}>
    <TabBarItemContainer active={to === location}>{children}</TabBarItemContainer>
  </Link>
);

const TabBarSlide = ({ children, slide, match, changeSlide }) => (
  <TabBarItemContainer onClick={() => changeSlide(match)} active={slide === match}>
    {children}
  </TabBarItemContainer>
);

TabBar.propTypes = {
  children: PropTypes.array.isRequired,
};

TabBarItem.propTypes = {
  children: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
};

TabBarSlide.propTypes = {
  children: PropTypes.shape().isRequired,
  slide: PropTypes.string.isRequired,
  match: PropTypes.bool.isRequired,
  changeSlide: PropTypes.func.isRequired,
};

export { TabBar, TabBarItem, TabBarSlide };
